// 每日爆料 · 单页内容演示数据（简体中文）
export const siteMeta = {
  brand: "每日爆料",
  slogan: "全网热点，一次看够",
  desc: "每日汇总盘点当日大事小情，从娱乐八卦到社会热点，不错过任何精彩。",
  contactEmail: "tougao@meiribaoliao.example",
  tipsEmail: "tipline@meiribaoliao.example",
};

export const tickers = [
  "今日全网新增讨论话题 328 条，热度峰值出现在上午 11 点",
  "娱乐榜榜首话题单小时热度突破 4.6 万，刷新本周纪录",
  "社会板块新增民生速览 12 则，正在实时更新中",
  "财经观察：消费与科技两条主线成为今日热议焦点",
  "本周盘点已上线，回看一周值得记住的大小事件",
];

export const hero = {
  eyebrow: "今日头条",
  title: "热搜再刷屏：娱乐与民生双线登顶今日话题榜首",
  lead: "从一档爆款综艺的收官夜到一条悄然刷屏的政策解读，今天的热搜榜单显得格外热闹。我们为你把最值得关注的几条线索拆开来看，一条不落。",
  tags: ["#热搜第一", "#全民讨论", "#今日刷屏"],
  image:
    "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20crowded%20city%20news%20scene%2C%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20accents%2C%20bold%20silhouettes%20of%20people%20reading%20phones%20and%20newspapers%2C%20minimalist%20modern%20visual%20with%20strong%20geometric%20shapes%2C%20clean%20layered%20composition%2C%20soft%20flat%20lighting%2C%20no%20text%2C%20high%20quality%20digital%20artwork&width=1600&height=900&seq=hero-daily-baoliao&orientation=landscape",
};

export type HotGroup = { key: string; label: string; items: { title: string; tag: string; hot: number }[] };
export const hotRanks: HotGroup[] = [
  {
    key: "all",
    label: "综合榜",
    items: [
      { title: "爆款综艺收官夜收视再创新高，收官名场面刷屏", tag: "娱乐", hot: 4.6 },
      { title: "新一轮消费促进行动公布，多品类迎利好解读", tag: "财经", hot: 4.1 },
      { title: "国产折叠屏新机发布即售罄，供应链订单看涨", tag: "科技", hot: 3.7 },
      { title: "多地优化出行预约流程，市民出行效率提升", tag: "民生", hot: 3.2 },
      { title: "国乒新星公开赛强势夺冠，闯入热搜前十", tag: "文体", hot: 2.9 },
      { title: "国际论坛聚焦绿色能源合作，引发广泛关注", tag: "国际", hot: 2.6 },
    ],
  },
  {
    key: "yule",
    label: "娱乐榜",
    items: [
      { title: "实力唱将演唱会官宣加场，票务预约人数激增", tag: "音乐", hot: 3.8 },
      { title: "热播剧大结局播出后话题霸榜，主创齐发声", tag: "剧集", hot: 3.5 },
      { title: "某顶流代言新品官宣，短时间登顶热搜", tag: "商务", hot: 3.1 },
      { title: "综艺路透画面流出，网友脑洞齐开引热议", tag: "综艺", hot: 2.7 },
      { title: "年度盛典红毯造型盘点，造型师集体圈粉", tag: "时尚", hot: 2.3 },
    ],
  },
  {
    key: "society",
    label: "社会榜",
    items: [
      { title: "暖心店主免费供饭走红，网友排队点赞", tag: "正能量", hot: 3.3 },
      { title: "社区养老驿站试点扩面，老人照护更省心", tag: "民生", hot: 2.8 },
      { title: "多城上线'一键挪车'，路面纠纷明显减少", tag: "出行", hot: 2.4 },
      { title: "垃圾分类新规实施满月，投放准确率提升", tag: "环境", hot: 2.1 },
      { title: "外卖骑手专属驿站再添一百家，暖冬行动启动", tag: "关注", hot: 1.9 },
    ],
  },
];

export const columns = [
  { key: "all", label: "全部", count: 48 },
  { key: "yule", label: "娱乐", count: 12 },
  { key: "shehui", label: "社会", count: 9 },
  { key: "keji", label: "科技", count: 7 },
  { key: "caijing", label: "财经", count: 6 },
  { key: "tihui", label: "文体", count: 5 },
  { key: "guonei", label: "民生", count: 9 },
];

export type Article = {
  id: number;
  cat: string;
  tag: string;
  time: string;
  hot: string;
  title: string;
  excerpt: string;
  img: string;
};
export const featured: Article[] = [
  {
    id: 1,
    cat: "娱乐",
    tag: "独家盘点",
    time: "09-09 09:20",
    hot: "2.4万",
    title: "爆款综艺收官名场面盘点：这五个瞬间最让人上头",
    excerpt: "一档综艺从盛夏火到初秋，收官夜的话题热度依旧居高不下。我们把全网讨论最多的几个名场面一次盘清，看看网友都在追什么。",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20bright%20concert%20stage%20with%20spotlights%20and%20cheering%20crowd%20silhouettes%2C%20warm%20cream%20background%2C%20vermilion%20and%20amber%20gold%20color%20palette%2C%20bold%20clean%20geometric%20shapes%2C%20energetic%20playful%20mood%2C%20minimalist%20modern%20style%2C%20soft%20flat%20light%2C%20no%20text&width=800&height=600&seq=art-yule-01&orientation=landscape",
  },
  {
    id: 2,
    cat: "社会",
    tag: "正能量",
    time: "09-09 11:40",
    hot: "3.1万",
    title: "一碗热汤面的温度：小店暖心事登上热搜后发生了什么",
    excerpt: "一家街角小店的善举被拍下后迅速刷屏。我们回访事件后续，看善意如何在网友的接力中不断放大。",
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20a%20cozy%20small%20street%20noodle%20shop%20with%20steaming%20bowl%20and%20friendly%20figures%2C%20cream%20and%20soft%20terracotta%20color%20palette%2C%20gentle%20morning%20light%2C%20minimalist%20geometric%20style%2C%20heartwarming%20everyday%20scene%2C%20clean%20modern%20composition%2C%20no%20text&width=800&height=600&seq=art-society-02&orientation=landscape",
  },
  {
    id: 3,
    cat: "科技",
    tag: "产品解读",
    time: "09-09 08:10",
    hot: "1.8万",
    title: "折叠屏新机凭什么开售即售罄？一文看懂三大升级",
    excerpt: "从铰链工艺到影像系统，再到轻薄机身，我们把这款热度爆表的新机拆解成三个看得懂的关键升级。",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20foldable%20smartphone%20floating%20with%20tech%20circuit%20motifs%20and%20abstract%20shapes%2C%20warm%20cream%20background%2C%20vermilion%20and%20amber%20accents%2C%20sleek%20modern%20minimal%20design%2C%20clean%20geometric%20composition%2C%20soft%20studio%20light%2C%20no%20text&width=800&height=600&seq=art-tech-03&orientation=landscape",
  },
  {
    id: 4,
    cat: "财经",
    tag: "市场观察",
    time: "09-09 10:05",
    hot: "2.2万",
    title: "消费主线再受关注：这份新政速览帮你划好重点",
    excerpt: "新一轮促消费政策发布，市场情绪迅速升温。我们把要点整理成一张可快速阅读的清单，方便你随时回看。",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20rising%20growth%20charts%20and%20coins%20with%20city%20skyline%20in%20background%2C%20warm%20cream%20palette%2C%20vermilion%20and%20golden%20amber%20colors%2C%20clean%20modern%20financial%20visual%2C%20geometric%20shapes%2C%20positive%20upward%20mood%2C%20soft%20lighting%2C%20no%20text&width=800&height=600&seq=art-fin-04&orientation=landscape",
  },
  {
    id: 5,
    cat: "文体",
    tag: "赛场直击",
    time: "09-09 07:30",
    hot: "1.5万",
    title: "国乒新星晋级路全记录：三场比赛三个关键词",
    excerpt: "从适应到爆发，这位年轻选手用三场比赛完成了自我证明。我们按节点复盘他的晋级之路。",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20table%20tennis%20player%20mid%20action%20with%20dynamic%20motion%20lines%20and%20bouncing%20ball%2C%20warm%20cream%20background%2C%20vermilion%20red%20and%20amber%20tones%2C%20energetic%20sporty%20minimal%20style%2C%20clean%20geometric%20shapes%2C%20soft%20flat%20lighting%2C%20no%20text&width=800&height=600&seq=art-sport-05&orientation=landscape",
  },
  {
    id: 6,
    cat: "民生",
    tag: "政策速览",
    time: "09-09 13:15",
    hot: "1.2万",
    title: "城市出行体验再优化：这四项新变化值得关注",
    excerpt: "预约流程更顺、停车指引更清、换乘提示更智能。我们用大白话把城市出行的新变化讲明白。",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20modern%20city%20street%20with%20bus%20and%20pedestrians%2C%20traffic%20lines%20and%20direction%20arrows%2C%20warm%20cream%20palette%2C%20vermilion%20and%20amber%20accents%2C%20clean%20minimal%20urban%20style%2C%20geometric%20shapes%2C%20soft%20daylight%2C%20no%20text&width=800&height=600&seq=art-city-06&orientation=landscape",
  },
  {
    id: 7,
    cat: "娱乐",
    tag: "热剧观察",
    time: "09-08 22:40",
    hot: "2.0万",
    title: "大结局播出后观众仍意难平？这些幕后细节更精彩",
    excerpt: "结局之外，从选角到服化道再到埋线彩蛋，我们扒出了剧迷必看的幕后二三事。",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20film%20set%20with%20camera%20clapperboard%20and%20spotlight%2C%20stage%20lights%20and%20curtains%2C%20warm%20cream%20background%2C%20vermilion%20and%20golden%20amber%20palette%2C%20dramatic%20yet%20clean%20minimal%20composition%2C%20geometric%20shapes%2C%20soft%20lighting%2C%20no%20text&width=800&height=600&seq=art-drama-07&orientation=landscape",
  },
  {
    id: 8,
    cat: "国际",
    tag: "环球速递",
    time: "09-08 20:00",
    hot: "1.1万",
    title: "一场聚焦绿色未来的论坛落幕，三个关键词刷屏",
    excerpt: "合作、创新与落地，成为这场国际论坛上出现频率最高的三个词。我们梳理出最值得记住的要点。",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20global%20summit%20scene%20with%20globe%20and%20green%20leaves%20and%20international%20flags%2C%20warm%20cream%20palette%2C%20vermilion%20amber%20and%20soft%20teal%20accents%2C%20clean%20minimal%20geometric%20composition%2C%20cooperative%20modern%20mood%2C%20soft%20lighting%2C%20no%20text&width=800&height=600&seq=art-global-08&orientation=landscape",
  },
];

export type WeekEvent = { day: string; cat: string; title: string; summary: string; mark?: boolean };
export const weeklyRecap: WeekEvent[] = [
  { day: "周一", cat: "娱乐", title: "暑期档收官：多部作品口碑回暖", summary: "随着最后一波新作定档，暑期档口碑榜尘埃落定，黑马作品逆袭成亮点。", mark: true },
  { day: "周二", cat: "科技", title: "新机扎堆发布，轻薄与影像成主战场", summary: "三场发布会集中上演，厂商围绕铰链、续航与影像展开贴身肉搏。" },
  { day: "周三", cat: "民生", title: "多地试点预约制，办事排队明显缩短", summary: "政务服务数字化提速，市民用一部手机即可完成多数预约。" },
  { day: "周四", cat: "文体", title: "大赛落幕，新生代集体交出成绩单", summary: "一批年轻选手在本周集中亮相，未来可期成为舆论共识。" },
  { day: "周五", cat: "财经", title: "消费新政落地，多品类迎实质利好", summary: "政策发布后市场情绪升温，零售与文旅板块受到更多关注。" },
  { day: "周末", cat: "合集", title: "全网热议话题周榜出炉", summary: "我们汇总一周讨论量最高的十个话题，做成了一份可收藏的周榜。", mark: true },
];

export type Collection = { tag: string; cat: string; items: string[] };
export const collections: Collection[] = [
  {
    tag: "文娱合集",
    cat: "娱乐大瓜周榜",
    items: [
      "从官宣到现场：一场演唱会引发的全民讨论",
      "热剧幕后：那些你没发现的镜头语言与彩蛋",
      "综艺名场面为何总能刷屏？幕后剪辑有讲究",
      "年度红毯造型盘点：设计师最满意的一笔",
      "音乐综艺破圈记：冷门好歌如何走向大众",
    ],
  },
  {
    tag: "观点合集",
    cat: "科技新动向观察",
    items: [
      "折叠屏成熟期：一场关于体验的较量",
      "大模型应用落地：办公场景最先受益",
      "智能汽车新配置盘点，哪些最实用",
      "AI 效率工具横评：谁才是打工人首选",
      "移动影像卷向何处：夜景与长焦成焦点",
    ],
  },
  {
    tag: "民生速览",
    cat: "本周生活服务要点",
    items: [
      "出行体验四项优化，收藏这篇就够了",
      "垃圾分类新规满月，这些误区要避开",
      "养老驿站扩面，老人照护更省心",
      "一键挪车上线，停车纠纷少了",
      "暖冬行动启动：外卖骑手驿站再扩容",
    ],
  },
];

export type Faq = { q: string; a: string };
export const faqs: Faq[] = [
  {
    q: "「每日爆料」的内容从哪里来？",
    a: "我们每天对全网公开讨论的热点话题进行整理、汇总与盘点，按娱乐、社会、科技、财经、民生等栏目分类呈现，方便你一站式纵览当天的重要信息，属于二次整理的资讯速览服务。",
  },
  {
    q: "每天什么时候更新？",
    a: "栏目内容会随话题热度滚动更新，通常在上午集中发布一期《每日精选》，晚间补充一份《今日盘点》，并在周末推出《本周合集》，方便你回看一周值得记住的大小事。",
  },
  {
    q: "热榜的排名依据是什么？",
    a: "热榜依据全网话题的讨论热度、传播速度与持续时间综合得出，榜单每间隔一段时间自动刷新，只反映当日讨论趋势，不代表任何立场或倾向。",
  },
  {
    q: "遇到不想看的内容或类别怎么办？",
    a: "在精选区上方可以直接切换栏目筛选，只看你感兴趣的类别；也可以在浏览时点击回到顶部按钮快速跳转，体验更顺畅。",
  },
  {
    q: "我有一条线索或素材想投稿，如何联系你们？",
    a: "欢迎把线索与素材发送到我们的投稿邮箱（tipline@meiribaoliao.example）。请确保信息真实、可溯源，我们会在核实与脱敏后纳入选题参考。",
  },
  {
    q: "可以转载或引用站内内容吗？",
    a: "站内原创整理内容欢迎在注明来源「每日爆料」后非商业性转载；若用于商业用途或大面积引用，请先通过投稿邮箱与我们取得联系确认授权。",
  },
];

export const aboutStats = [
  { num: "3", unit: "大", label: "每日精选栏目" },
  { num: "12", unit: "类", label: "主题盘点覆盖" },
  { num: "24", unit: "期", label: "本周合集累计" },
  { num: "7", unit: "×24", label: "热度持续追踪" },
];